import scene from "./settings";
import scene1 from "./img/scene1.png";
import scene2 from "./img/scene2.png";
import scene3 from "./img/scene3.png";
import scene4 from "./img/scene4.png";
import scene5 from "./img/scene5.png";
import opt1 from "./img/1.png";
import opt3 from "./img/3.png";
import opt4 from "./img/4.png";

const SCENE_IMAGES = {
  "scene1.png": scene1,
  "scene2.png": scene2,
  "scene3.png": scene3,
  "scene4.png": scene4,
  "scene5.png": scene5,
};

const OPTION_IMAGES = {
  "1.png": opt1,
  "3.png": opt3,
  "4.png": opt4,
};

function resolveOption(opt, hasOptionImage) {
  if (hasOptionImage && OPTION_IMAGES[opt]) return OPTION_IMAGES[opt];
  if (OPTION_IMAGES[opt]) return OPTION_IMAGES[opt];
  return opt;
}

/** settings.js scenes with ./img/ assets resolved for the bundler. */
export const STAGE1_SCENES = scene.map((sc) => ({
  ...sc,
  scene_image: SCENE_IMAGES[sc.scene_image] || sc.scene_image,
  options: (sc.options || []).map((opt) =>
    resolveOption(opt, sc.has_option_image)
  ),
  show_led: false,
}));

export const STAGE1_DATE_ANSWER = "1947-08-15";
export const STAGE1_LAST_SCENE_INDEX = STAGE1_SCENES.length - 1;

export const STAGE1_MAX_POINTS = STAGE1_SCENES.reduce(
  (sum, sc) => sum + (Number(sc.count_points) || 0),
  0
);
